import React, { useState, useEffect } from "react";
import { Link,useNavigate,useLocation } from "react-router-dom";
import {
  Radio,
  Form,
  Input,
  message,
  Button,
  Steps,
  Modal,
  Spin,
} from "antd";
import nujobsImg from "../../../assets/landingFeatures/explorer.png";
import { actionsNuJobs } from "../../../actions";
import "./otpprocess.css";
import { useDispatch } from "react-redux";
import useMembersStore from "../../../store/members.store";
import { LoadingOutlined } from "@ant-design/icons";
import useNuJobsStore from "../../../store/nujobs.store";

export default function NUJobsOTPProcess() {
    const [loader, SetLoader] = useState(false);
    const [formKey1, setFormKey1] = useState(1);
    const [nextState, setNextState] = useState(0)
  const [timer, setTimer] = useState();
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [resendOTPLoader, setResendOTPLoader] = useState(false);
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const[error,setError] = useState("")
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { setSubscription } = useMembersStore();
  const [messageApi, contextHolder] = message.useMessage();

    let location = useLocation();
    const { reason, trigger,signupemail } = location.state || {};
    var value = reason;
    var localTrigger = trigger;
    const { getOSAllJds, currentSearch,applyNowPopUpRouting,applyNowJd } = useNuJobsStore(); 

    const [inputData, setFormData] = useState({
      otp:"",
      username: "",
      contact: "",
      email: "",
    });

    useEffect(() => {
        //console.log("location", location.state);
    }, []);

  useEffect(() => {
    let interval;
    if (isResendDisabled && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTime) => prevTime - 1);
      }, 1000);
    } else {
      setIsResendDisabled(false);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timer, isResendDisabled]);

  const successOTP = () => {
    messageApi.open({
      type: "success",
      content: "OTP sent successfully",
    });
  };

  const errorOTP = () => {
    messageApi.open({
      type: "error",
      content: "OTP sent failed",
    });
  };

  const handleFormSubmit = (values) => {};
    const showModal = () => {
      setIsModalOpen(true);
    };
  
    const handleOk = () => {
      setIsModalOpen(false);
    };
  
    const handleCancel = () => {
      setIsModalOpen(false);
    };

    const dispatchSignIn = (values) =>{

      SetLoader(true);
      dispatch(actionsNuJobs.NuJobsSignIn(inputData, (error, status) => {
        if (!error) {
          navigate("/nujobsotpprocess", { state: {  reason: "verifyotp" ,trigger: localTrigger } });
          setIsResendDisabled(true);
          setTimer(5);
          SetLoader(false);       
          successOTP();
        } else {
          // Handle the error case
          SetLoader(false);
          console.error("API Error:", error);
         
          if( error === "decode error"){
            setError("Kindly fill right details." ); // Set the error message in state
          }else if( error === "please sign in"){
            setError("Account already created, kindly sign in."); // Set the error message in state
          }else if( error === "verification pending"){
            setError("OTP Ve=rification pending, Kindly verify your email id."); // Set the error message in state
          }else {
            setError(error)
          }
          showModal()
          //console.log("status", status);
        }
      }));

      if (nextState) {
        localTrigger = "signin"
        value ="verifyotp" 
        setNextState(1)
      }
       
    }
    const dispatchAlreadygotOtp = (values) =>{

        SetLoader(true);
        dispatch(actionsNuJobs.NuJobsSignup(inputData, (error, status) => {
          if (!error) {
            navigate("/otp", { state: { inputData, type: "signup" } });
            SetLoader(false);
          } else {
            // Handle the error case
            SetLoader(false);
            console.error("API Error:", error);
           
            if( error === "decode error"){
              setError("Kindly fill right details." ); // Set the error message in state
            }else if( error === "please sign in"){
              setError("Account already created, kindly sign in."); // Set the error message in state
            }else if( error === "verification pending"){
              setError("OTP Verification pending, Kindly verify your email id."); // Set the error message in state
            }else {
              setError(error)
            }
            showModal()
            ////console.log("status", status);
          }
        }));        
    }
    const dispatchResendOtp = (values) =>{

    setResendOTPLoader(true);
    //console.log("inputData: ", inputData);
    // setResendOTPLoader(true);
    dispatch(
      actionsNuJobs.NuJobsResendOTP({ email: inputData.email }, (error, status) => {
        if (!error) {
          navigate("/nujobsotpprocess", {
            state: {
              reason: "verifyotp",
              trigger: localTrigger,
              value: "resend",
            },
          });
          SetLoader(false);
          setResendOTPLoader(false);
          setIsResendDisabled(true);
          setTimer(5);
          successOTP();
          } else {
            // Handle the error case
            SetLoader(false);
            console.error("API Error:", error);
           
            if( error === "decode error"){
              setError("Kindly fill right details." ); // Set the error message in state
            }else if( error === "please sign in"){
              setError("Account already created, kindly sign in."); // Set the error message in state
            }else if( error === "verification pending"){
              setError("OTP Verification pending, Kindly verify your email id."); // Set the error message in state
            }else {
              setError(error)
            }
          // showModal();
          // fail();
           // console.log("status", status);
          }
        }));        
    }

    const continueSearch = () =>{
      if(applyNowPopUpRouting){
          navigate(`/nujobshome/nujobsafterlogin/${applyNowJd?.qhoid}/${applyNowJd?.qhcompanyjid}`);
      } else if(currentSearch!=null){
          getOSAllJds(currentSearch,()=>  navigate(`/nujobshome/nujobsSearchResultHandler`))
      }else{
        navigate("/nujobshome/nujobssearch")
      }        
    }

    const dispatchVerifyOtp = (values) =>{
        SetLoader(true);
        dispatch(actionsNuJobs.NuJobsVerifySignInOtp(inputData, (error, status) => {
          if (!error) {
            //setSubscription()
            continueSearch()
            SetLoader(false);
          } else {
            // Handle the error case
            SetLoader(false);
            console.error("API Error:", error,status);
           
            if( error == "decode error"){
              setError("Kindly fill right details." ); // Set the error message in state
            }else if( error == "please sign in"){
              setError("Account already created, kindly sign in."); // Set the error message in state
            }else if( error == "verification pending"){
              setError("OTP Verification pending, Kindly verify your email id."); // Set the error message in state
          } else if (error == "Incorrect OTP") {
            setError("Incorrect OTP, Please Enter Correct OTP");
          } // Set the error message in state
          else {
            setError(error);
          }
          showModal();
          //console.log("status", status);
        }
      })
    );
  };
  const dispatchVerifyAccountOtp = (values) => {
    SetLoader(true);
    inputData.email = signupemail;
    dispatch(
      actionsNuJobs.NuJobsVerifyAccountOtp(inputData, (error, status) => {
        if (!error) {
          continueSearch()
          SetLoader(false);
        } else {
          // Handle the error case
          SetLoader(false);
          console.error("API Error:", error);

          if (error == "decode error") {
            setError("Kindly fill right details."); // Set the error message in state
          } else if (error == "please sign in") {
            setError("Account already created, kindly sign in."); // Set the error message in state
          } else if (error == "verification pending") {
            setError("Email Verification pending, Kindly verify."); // Set the error message in state
          } else {
            setError(error);
          }
          showModal();
          //console.log("status", status);
        }
      })
    );
  };
  const handleOtpProcess = (values) => {
    //console.log("formData", inputData);
    // SetLoader(true);

    if (localTrigger == "signin" && value == "start") {
      dispatchSignIn();
    }
    if (localTrigger == "signup" && value == "verifyotp") {
      dispatchVerifyAccountOtp();
    }
    if (localTrigger == "signin" && value == "verifyotp") {
      dispatchVerifyOtp();
    }
    if (value == "resend") {
      dispatchResendOtp();
    }
    if (value == "alreadygot") {
      dispatchAlreadygotOtp();
    }
  };
  const handleChange = (e) => {
    //console.log("handle change", e);
    //console.log("input values", inputData);
    const { name, value } = e.target;
    if (name == "email") {
      setFormData({ ...inputData, [name]: value?.trim()?.toLowerCase() });
    } else {
      setFormData({ ...inputData, [name]: value.trim() });
    }
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins < 10 ? `0${mins}` : mins}:${secs < 10 ? `0${secs}` : secs}`;
  };
    return (
     <div className="nujobsotpprocess-wrapper">
      {contextHolder}
        <div className="otpprocess-form-wrapper">
          <div className="signupnew-leftarea">
              <div className="nujobs-login-left-content">
                <Link to = "/nujobs">
                  <img
                    src={nujobsImg}
                    alt="Explorer"
                    width="230" height="auto" 
                  />                 
                </Link>
                <div className="nujobs-login-branding">
                  <h2>Find the Right Job. From the Right Company.</h2>
                  <p>Multiple Companies.One Platform.</p>
                </div>                
              </div>         
          </div>

          <div className="signupnew-rightarea"> 
          <div className="signupnew-heading">
               {localTrigger == "signin"?
                reason == "start" ? <>Sign In to NuJobs</>:<>Continue Sign In to NuJobs</>
                :<>Continue Sign Up to NuJobs <br></br></>}
          </div> 
            <Form
              key={formKey1}
              className="profile-form"
              name="signon-form"
              justify="start"
              layout="vertical"
              autoComplete="off"
              onFinish={handleOtpProcess}
             >                    
             {
                value != "verifyotp"?
                <>
                    <Form.Item
                                rules={[{ required: true, message: 'Email ID  required!' }]}                          
                                className="profile-field-item"
                                label="Email ID"
                                name="email"
                                normalize={(value) => value.trim().toLowerCase()}
                            >
                                <Input
                                    className="profile-input-full"
                                    onChange={handleChange}
                                    name="email"
                    placeholder="Enter Email ID"
                                />
                    </Form.Item>   
                    <Form.Item
                            rules={[{ required: true, message: 'Mobile Number  required!' }]}     
                            className="profile-field-item"
                            label="Mobile Number"
                            name="contact"
                        >
                            <Input
                            className="profile-input-full"
                            onChange={handleChange}
                            name="contact"
                    placeholder="Enter Mobile Number"
                            />
                        </Form.Item>                                 
                </>:
                <></>
             }

             {
                value == "alreadygot" || value == "verifyotp"
                ?<>
                <div className="otp-sent-info">
                  OTP sent to{" "}
                  <span className="otp-sent-info-email">
                    {inputData.email ? inputData.email : signupemail}
                  </span>
                </div>
                   <Form.Item
                      required = {true}
                      className="profile-field-item"
                      label="OTP"
                      name="validotp"
                  >
                      <Input
                          required = {true}
                          className="profile-input-full"
                          onChange={handleChange}
                          name="otp"
                    placeholder="Enter OTP"
                      />
                  </Form.Item>               
                </>
                :<> </>
             } 

                <Button
                    style={{ width: "100%", height: "40px", fontWeight: "600" }}
                    type="primary"
                    htmlType="submit"
                >
              {loader ? (
                <Spin
                  indicator={
                    <LoadingOutlined style={{ color: "white" }} spin />
                  }
                />
              ) : value == "start" ? (
                <>Sign In</>
              ) : value == "verifyemail" ? (
                <>Verify Email ID</>
              ) : value == "verifyotp" ? (
                <>Verify OTP</>
              ) : value == "alreadygot" ? (
                <>Verify OTP</>
              ) : (
                <>Resend OTP</>
              )}
                </Button>           
            </Form>  
            {
              <Modal title={trigger=="signin"?"Sign In":"Sign Up"} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                 {error}
              </Modal>
            }
            <div className="signupnew-links-wrapper">
            {localTrigger == "signin" && value == "verifyotp" ? (
              <div className="signupnew-links">
                {!resendOTPLoader ? (
                  <p
                    onClick={(e) => {
                      if (isResendDisabled) {
                        e.preventDefault();
                      } else {
                        dispatchResendOtp();
                      }
                    }}
                    style={{
                      pointerEvents: isResendDisabled ? "none" : "auto",
                      color: isResendDisabled ? "gray" : "blue",
                      cursor: isResendDisabled ? "not-allowed" : "pointer",
                      textDecorationLine: "underline",
                    }}
                  >
                    Resend OTP{" "}
                    {isResendDisabled ? "In " + formatTime(timer) : ""}
                  </p>
                ) : (
                  <>
                    <p>
                      Please Wait
                      <Spin
                        style={{ marginLeft: "10px" }}
                        indicator={<LoadingOutlined spin />}
                        size="small"
                      />
                    </p>
                  </>
                )}
              </div>
            ) : (
              <></>
            )}
               
          </div>

            <div className="signupnew-links-wrapper">             
              <div className="signupnew-links">
                <Link
                  to={"/nujobsotpprocess"}
                  state= {{ reason: "start" ,trigger: "signin"}} 
                > 
                  Sign In
                </Link>
              </div> 
              <div className="signupnew-links">
                <Link
                  to={"/nujobsotpprocess"}
                state={{ reason: "alreadygot", trigger: localTrigger }}
                > 
                Got Valid OTP?
                </Link>
              </div>   
              <div className="signupnew-links">
              <Link to="/nujobssignup">New Account Sign up</Link>
                
              </div>            
            </div>         
          </div>
        </div>

        <div className="otpprocess-footer">
        <div>
          <p>
              Nujobs is part of QuallyHire AI Product Family from HMW Communications Pvt. Ltd
          </p>
        </div>
        <div>
          <a>
            <p>
              Dont have an account ? <Link to={'/nujobssignup'}> Sign up Now!</Link>
            </p>
          </a>
        </div>
        </div>
     </div>

    );
}
